import api from "../../../services/axiosConfig";
import createModuleApi from "../../../services/createModuleApi";

const crud = createModuleApi("/instances/governeye/jeyeda", {
  endpoints: { create: "/add-user" },
});

export const fetchUsers = crud.fetchAll;
export const createUser = crud.create;
export const deleteUser = crud.remove;

export const updateUserRole = async (userId, roleValue) => {
  const res = await api.put(
    `/instances/governeye/jeyeda/update-user-role/${userId}`,
    { role: roleValue },
  );
  return res.data;
};
